import { Box, Typography } from "@mui/material";
import cluppcitoHappy from "../../../Assets/Clupp_Festejo.png";
import Confetti from "react-confetti";
import { useEffect, useState } from "react";
import { formatCurrency } from "../../../utils/formatCurrency";

const AceptDiscount = ({ state, setState, field }) => {
  const [run, setRun] = useState(true);

  useEffect(() => {
    setTimeout(() => setRun((r) => !r), 5000);
  }, []);
  return (
    <>
      {!state.haveAnActiveDiscount && (
        <Confetti tweenDuration={10000} recycle={run} />
      )}
      <Box textAlign="center" width="100%" padding={0}>
        <img
          src={cluppcitoHappy}
          alt="Cluppcito Happy"
          style={{ width: 150, height: 170, marginBottom: 3 }}
        />
        {state.haveAnActiveDiscount ? (
          <Typography variant="h6">
            Ya tienes un cupon activo del dia{" "}
            {state.cancelationDiscountAcceptedAt}. No puedes aplicar otro
            nuevamente.
          </Typography>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              ¡Gracias por quedarte con Clupp!
            </Typography>
            <Typography variant="body1">
              {`Nos gustaría revisar contigo los valores de tu prima y cómo quedarían a partir de ahora.`}
            </Typography>
            <Box
              sx={{
                mt: 3,
                mx: "auto",
                width: "90%",
                p: 1,
                borderRadius: "8px",
                backgroundColor: "#E3F2FD",
                textAlign: "center",
              }}
            >
              <Typography variant="h6">
                Actualmente pagas: {formatCurrency(state?.premium)}.
              </Typography>
              <Typography variant="h6" sx={{ fontSize: "18px" }}>
                Aplicamos un descuento del:{" "}
                <span style={{ fontWeight: 700 }}>{state?.discount}%</span>.
              </Typography>
              <br />

              {state?.nextPayment && (
                <Typography variant="h6" sx={{ fontSize: "18px" }}>
                  Tu próxima fecha de pago será el:{" "}
                  <span style={{ fontWeight: 700 }}>{state?.nextPayment}</span>.
                  Y será por:{" "}
                  <span style={{ fontWeight: 700 }}>
                    {formatCurrency(state?.nextPaymentAmount)}
                  </span>
                  .
                </Typography>
              )}
              <br />
              <Typography variant="h6">
                Luego, pasarás a pagar{" "}
                <span style={{ fontWeight: 700 }}>
                  {formatCurrency(state?.premiumWithDiscount)}
                </span>{" "}
                de manera {state?.period}.
              </Typography>
              <Typography variant="body1">
                Esto incluye las coberturas extras que tiene contratadas.
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{ fontWeight: 600, marginTop: "15px" }}
            >
              ¡Gracias de nuevo por elegirnos!
              <span role="img" aria-label="thumbs up">
                👍🏼
              </span>
            </Typography>
          </>
        )}
      </Box>
    </>
  );
};
export default AceptDiscount;
